interface IRegions {
    [regionIsoCode: string]: {
        default: string,
        [cityName: string]: string | undefined,
    },
}

export const regions: IRegions = {
    'RU-ALT': {
        default: 'barnaul',
    },
    'RU-BRY': {
        default: 'bryansk',
    },
    'RU-VGG': {
        default: 'volgograd',
        'Волжский': 'vlz',
    },
    'RU-VOR': {
        default: 'voronezh',
    },
    'RU-KIR': {
        default: 'kirov',
    },
    'RU-KYA': {
        default: 'krsk',
    },
    'RU-KDA': {
        default: 'krd',
    },
    'RU-LIP': {
        default: 'lipetsk',
    },
    'RU-NIZ': {
        default: 'nn',
        'Дзержинск': 'dzr',
    },
    'RU-NVS': {
        default: 'nsk',
    },
    'RU-OMS': {
        default: 'omsk',
    },
    'RU-ORE': {
        default: 'oren',
    },
    'RU-PNZ': {
        default: 'penza',
    },
    'RU-PER': {
        default: 'perm',
        'Березники': 'ber',
        'Чусовой': 'chus',
        'Кунгур': 'kungur',
        'Соликамск': 'slk',
    },
    'RU-ME': {
        default: 'yola',
    },
    'RU-TA': {
        default: 'kazan',
        'Набережные Челны': 'chelny',
        'Нижнекамск': 'nk',
    },
    'RU-MOW': {
        default: 'msk',
    },
    'RU-MOS': {
        default: 'msk',
    },
    'RU-TAM': {
        default: 'mich',
    },
    'RU-ROS': {
        default: 'rostov',
    },
    'RU-BU': {
        default: 'ulu',
    },
    'RU-LEN': {
        default: 'sbor',
    },
    'RU-UD': {
        default: 'izhevsk',
    },
    'RU-CU': {
        default: 'cheb',
    },
    'RU-RYA': {
        default: 'ryazan',
    },
    'RU-SAM': {
        default: 'samara',
        'Сызрань': 'syzran',
    },
    'RU-SPE': {
        default: 'interzet',
    },
    'RU-SAR': {
        default: 'saratov',
        'Энгельс': 'engels',
    },
    'RU-SVE': {
        default: 'ekat',
    },
    'RU-TYU': {
        default: 'tmn',
    },
    'RU-CHE': {
        default: 'chel',
        'Магнитогорск': 'mgn',
    },
    'RU-YAR': {
        default: 'yar',
    },
    'RU-TUL': {
        default: 'tula',
    },
    'RU-IRK': {
        default: 'irkutsk',
        'Усолье-Сибирское': 'usol',
        'Ангарск': 'angarsk',
    },
    'RU-TOM': {
        default: 'tomsk',
        'Северск': 'seversk',
    },
    'RU-KGN': {
        default: 'kurgan',
    },
    'RU-KRS': {
        default: 'kursk',
    },
    'RU-TVE': {
        default: 'tver',
    },
    'RU-BA': {
        default: 'ufa',
    },
    'RU-ULY': {
        default: 'ulsk',
        'Димитровград': 'dimgrad',
    },
};
